import { render, staticRenderFns } from "./zuimintj.vue?vue&type=template&id=2928dcf6&scoped=true&"
import script from "./zuimintj.vue?vue&type=script&lang=js&"
export * from "./zuimintj.vue?vue&type=script&lang=js&"
import style0 from "./zuimintj.vue?vue&type=style&index=0&id=2928dcf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2928dcf6",
  null
  
)

export default component.exports